export const role = state => state.role

export const surveyRole = state => state.surveyRole

export const attention = state => state.attention

export const guidePage = state => state.guidePage

export const surveyType = state => state.surveyType

export const shareSurvey = state => state.shareSurvey

export const userInfo = state => state.userInfo



// WEBPACK FOOTER //
// ./src/store/getters.js